import React, { forwardRef } from "react";

const Input = forwardRef(function Input(
  { label, error, hint, icon, iconRight, className = "", wrapClass = "", ...props },
  ref
) {
  return (
    <div className={`flex flex-col gap-1.5 ${wrapClass}`}>
      {label && (
        <label className="text-sm font-medium text-slate-700 dark:text-slate-200">
          {label}
        </label>
      )}
      <div className="relative">
        {icon && (
          <span className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-500 dark:text-slate-400 pointer-events-none">
            {icon}
          </span>
        )}
        <input
          ref={ref}
          className={`
            w-full h-10 px-3 rounded-xl border text-sm bg-white dark:bg-slate-800
            text-slate-900 dark:text-slate-100
            border-slate-200 dark:border-slate-600
            placeholder:text-slate-500 dark:placeholder:text-slate-400
            focus:outline-none focus:ring-2 focus:ring-brand-500 focus:border-transparent
            transition-all duration-200
            disabled:opacity-50 disabled:cursor-not-allowed
            ${icon ? "pl-9" : ""}
            ${iconRight ? "pr-9" : ""}
            ${error ? "border-red-400 focus:ring-red-400" : ""}
            ${className}
          `}
          {...props}
        />
        {iconRight && (
          <span className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-500 dark:text-slate-400">
            {iconRight}
          </span>
        )}
      </div>
      {error && <p className="text-xs text-red-500">{error}</p>}
      {hint && !error && <p className="text-xs text-slate-500 dark:text-slate-400">{hint}</p>}
    </div>
  );
});

export default Input;
